import React, { useEffect, useState } from 'react' // Import useState and React
import OttImageComponent from './OttImageComponent'

const RenderOttLink = ({
  ott,
  Movielinks,
  ottFreeStatus,
  setOttindex,
  setPop,
  defaultBehaviourEnter,
  links,
  handleFreeStatusChange,
  removeFields,
  input,
  index,
  inputData,
  sendinputdata,
  sendBooleanValueChangeDone,
  link,
}) => {
  const [selectedLanguages, setSelectedLanguages] = useState([])
  const renderOttLinkChild = (input, index) => {
    const ottPlatform = ott[index]?.value || ''
    const ottLink = Movielinks[index]?.link || ''
    const ottLinkSplit = ottLink.split('|free')[0]

    const handleLinkChange = event => {
      // Extract the current ottFreeStatus for the current index
      const isFree = ottFreeStatus[index]

      // Trim and split the entered ottLink
      const ottLinkSplit = event.target.value.trim().split('|free')[0]

      // If ottFreeStatus is true for the current index, append '|free' to the ottLink, otherwise use it as it is
      const newOttLink = isFree ? ottLinkSplit + '|free' : ottLinkSplit

      // Call the 'links' function passed from props to update the ott link
      links(newOttLink, index)
    }

    const handleLanguageChange = language => {
      // Toggle language selection
      const selectedIndex = selectedLanguages.indexOf(language)
      let newLanguages

      if (selectedIndex === -1) {
        // Add the language if it's not already selected
        newLanguages = [...selectedLanguages, language]
      } else {
        // Remove the language if it's already selected
        newLanguages = [...selectedLanguages]
        newLanguages.splice(selectedIndex, 1)
      }

      // Update the selected languages state
      setSelectedLanguages(newLanguages)

      // Get the platform label for the current index
      const platformLabel = ott[index]?.label || ''

      // Find the index of the platform in the input data
      const matchedPlatformIndex = inputData.OTTPlatformsWithLangs.findIndex(
        platform => platform.availablePlatform === platformLabel,
      )

      // Prepare the new platform object with updated languages
      const updatedPlatform = {
        availablePlatform: platformLabel,
        availableLanguages: newLanguages, // Use the updated languages
      }

      // Update the input data
      const inputDataTemp = { ...inputData }
      if (matchedPlatformIndex === -1) {
        // If the platform doesn't exist, push a new platform object
        inputDataTemp.OTTPlatformsWithLangs.push(updatedPlatform)
      } else {
        // If the platform exists, update its languages
        inputDataTemp.OTTPlatformsWithLangs[
          matchedPlatformIndex
        ] = updatedPlatform
      }

      // Send the updated input data to the parent component
      sendinputdata(inputDataTemp)
      sendBooleanValueChangeDone('OTTPlatformsWithLangs', true)
    }

    const handleImageClick = () => {
      setOttindex(index)
      setPop(true)
    }

    const isFree = ottFreeStatus[index]

    const languages = ['Te', 'Hi', 'Ml', 'Kn', 'Ta', 'En'] //  languages
    return (
      <div className='cast' key={index}>
        <label>{`Ott links ${index + 1}`}</label>
        <div className='d-flex flex-column'>
          <div className='ottImageContainer'>
            {/* Assuming OttImageComponent is another component */}
            <OttImageComponent
              handleImageClick={handleImageClick}
              ottPlatform={ottPlatform}
            />

            <input
              type='url'
              value={ottLinkSplit}
              placeholder='ott link'
              onChange={handleLinkChange}
              onKeyDown={defaultBehaviourEnter}
              className='rounded'
              style={{ width: '100%' }}
            />

            <label>
              Free:
              <input
                type='checkbox'
                checked={isFree}
                onChange={() => handleFreeStatusChange(index)}
                onKeyDown={defaultBehaviourEnter}
              />
            </label>
            {Movielinks.length > 0 && (
              <button
                className='remove btn btn-danger ottCancelButton'
                onClick={() => removeFields(index)}
              >
                X
              </button>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {languages.map(language => (
              <label key={language}>
                {language}
                <input
                  type='checkbox'
                  checked={selectedLanguages.includes(language)}
                  onChange={() => handleLanguageChange(language)}
                />
              </label>
            ))}
          </div>
        </div>
        {!(ottPlatform && ottLink.length >= 8) && (
          <span className='mandatory1'>
            Ott platform and Ott link are mandatory when one of them is selected
          </span>
        )}
        {!link && <span className='mandatory1'>Enter a valid URL</span>}
      </div>
    )
  }

  useEffect(() => {
    const ottplatform = ott[index]?.label || ''

    // Use map to find the matching OTT platform and extract its languages
    const matchedPlatform = inputData.OTTPlatformsWithLangs.find(
      platform => platform.availablePlatform === ottplatform,
    )

    const languages = matchedPlatform ? matchedPlatform.availableLanguages : []
    // Now 'languages' array contains the languages for the matched OTT platform
    setSelectedLanguages(languages)
  }, [inputData.OTTPlatformsWithLangs])
  return renderOttLinkChild(input, index) // Returning the function inside the component
}

export default RenderOttLink
